import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFromTrain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21 13C21 9.1 17.6 6 11 6H3",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 15H19C19.5 15 20 14.8 20.4 14.4C20.8 14 21 13.5 21 13",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 11H20.5",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 11V6.5",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 19H21",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 10.5H1.5",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 12.7L1.5 10.5L4.5 8.29999",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.09998 17C4.09998 17.5 4.29998 18 4.69998 18.4C5.09998 18.8 5.59998 19 6.09998 19C6.59998 19 7.09998 18.8 7.49998 18.4C7.89998 18 8.09998 17.5 8.09998 17C8.09998 16.5 7.89998 16 7.49998 15.6C7.19998 15.2 6.59998 15 6.09998 15C5.59998 15 5.09998 15.2 4.69998 15.6C4.29998 16 4.09998 16.5 4.09998 17Z",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3 17C14.3 17.5 14.5 18 14.9 18.4C15.3 18.8 15.8 19 16.3 19C16.8 19 17.3 18.8 17.7 18.4C18.1 18 18.3 17.5 18.3 17C18.3 16.5 18.1 16 17.7 15.6C17.3 15.2 16.8 15 16.3 15C15.8 15 15.3 15.2 14.9 15.6C14.5 16 14.3 16.5 14.3 17Z",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.19995 3.29999C1.59995 3.29999 1.99995 3.19999 2.39995 2.99999C2.69995 2.89999 2.99995 2.59999 3.19995 2.29999C3.39995 1.99999 3.69995 1.69999 4.09995 1.59999C4.39995 1.39999 4.79995 1.29999 5.19995 1.29999C5.59995 1.29999 5.99995 1.39999 6.29995 1.59999C6.69995 1.69999 6.99995 1.99999 7.19995 2.29999C7.39995 2.59999 7.79995 2.89999 8.09995 2.99999C8.39995 3.19999 8.79995 3.29999 9.19995 3.29999C9.59995 3.29999 9.99995 3.19999 10.3 2.99999C10.6 2.79999 10.9 2.59999 11.2 2.29999",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8 6.29999V2.29999H13.8",
			stroke: "#9C2D18",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFromTrain;
